import {gql} from '@apollo/client';
import {NOTE_DETAILS_FRAGMENT, NOTE_FRAGMENT} from '../../graphql/fragments';

export const GET_HANDOVER_NOTES_QUERY_CURRENT_ONLY = gql`
  query GetHandoverNotesCurrentOnly(
    $keyId: String!
    $valueId: UUID!
    $activeOnly: Boolean
  ) {
    reviewDetails(keyId: $keyId, valueId: $valueId, activeOnly: $activeOnly) {
      ...HandoverNotesReviewDetailsFragment
    }
  }
  ${NOTE_DETAILS_FRAGMENT}
`;
export const GET_HANDOVER_NOTES_QUERY = gql`
  query GetHandoverNotes(
    $keyId: String!
    $valueId: UUID!
    $accountId: UUID!
    $activeOnly: Boolean
    $contactId: UUID
  ) {
    reviewDetails(keyId: $keyId, valueId: $valueId, activeOnly: $activeOnly) {
      ...HandoverNotesReviewDetailsFragment
    }
    previousNotes(
      keyId: "account_id"
      valueId: $accountId
      contactKeyId: "contact_id"
      contactValueId: $contactId
    ) {
      ...HandoverNotesReviewDetailsFragment
    }
  }
  ${NOTE_DETAILS_FRAGMENT}
`;

export const PREVIOUS_HANDOVER_NOTES_QUERY = gql`
  query GetPreviousNotes($accountId: UUID!, $contactId: UUID) {
    previousNotes(
      keyId: "account_id"
      valueId: $accountId
      contactKeyId: "contact_id"
      contactValueId: $contactId
    ) {
      ...HandoverNotesReviewDetailsFragment
    }
  }
  ${NOTE_DETAILS_FRAGMENT}
`;

export const UPDATE_NOTE_MUTATION = gql`
  mutation UpdateNote(
    $noteId: UUID!
    $name: String
    $body: String
    $reviewed: String
    $markupBody: String
  ) {
    updateNote(
      noteId: $noteId
      name: $name
      body: $body
      reviewed: $reviewed
      markupBody: $markupBody
    ) {
      ok
      note {
        ...NoteFragment
      }
    }
  }
  ${NOTE_FRAGMENT}
`;

export const UPDATE_EDITED_NOTES_MUTATION = gql`
  mutation UpdateEditedNotes($reviewId: UUID!) {
    updateReview(reviewId: $reviewId, notesEdited: true, isInJourney: true) {
      review {
        id
        notesEdited
      }
    }
  }
`;
